import { render, staticRenderFns } from "./TransferReceivedHint.vue?vue&type=template&id=5d390172&"
import script from "./TransferReceivedHint.vue?vue&type=script&lang=js&"
export * from "./TransferReceivedHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports